import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { XCircle } from "react-bootstrap-icons";
import { SubmitButton, CancelButton } from "../../shared";

export function RejectModal({
  target,
  onCancel,
  onConfirm,
  isSubmitting = false,
}) {
  const [reason, setReason] = useState("");

  return (
    <Modal show onHide={onCancel} centered className="commission-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">Decline — {target.label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-secondary small mb-3">
          This commission won’t be paid, nor will it come back through in future
          payouts, if eligible.
        </p>
        <Form.Group>
          <Form.Label className="field-label">Reason (optional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="e.g. Duplicate contract, calculated in error, disputed by ops…"
            disabled={isSubmitting}
            autoFocus
          />
          <Form.Text className="char-counter">{reason.length}/500</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={onCancel} disabled={isSubmitting} />
        <SubmitButton
          text="Decline"
          color="red"
          isSubmitting={isSubmitting}
          onClick={() => onConfirm(reason.trim() || null)}
          icon={<XCircle size={14} />}
        />
      </Modal.Footer>
    </Modal>
  );
}
